import axios from "axios"
import { Account } from "@/api/interface/account"

export const getAccount = (): Promise<Account> =>
  axios.get(`v2/account/`).then((res) => res.data.data)

export const deleteAccount = (accountId: Account['id']) => {
  axios.delete(`v2/users/${accountId}/trash`)
}